import { Cloudinary } from '@cloudinary/url-gen';

import { env } from '../env';

export const cloudinary = new Cloudinary({
	cloud: {
		cloudName: env.cloudinary.cloudName,
	},
});
